import { TableBodyCell, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const LoadingContainer = styled.div `
  display: flex;
  padding: ${theme.spacing.xl};
  align-items: center;
  justify-content: center;
`;
export const MediumTableBodyCell = styled(TableBodyCell) `
  max-width: ${pxToRem(400)};
`;
